import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from '#imports';
import { SINGLETON_KEY } from '#layers/workspace/rstore/utils/singleton';

/**
 * The organization's branding: its settings singleton (logo, colour) and a display name that
 * falls back to a generic label when unset. Shared by the workspace switcher and the org header.
 */
export function useOrgBranding() {
	const { t } = useI18n();
	const store = useStore();

	const { data: orgSettings } = store.MonospaceOrgSettings.query((q) => q.first({ key: SINGLETON_KEY }));

	const orgName = computed(() => orgSettings.value?.name ?? t('common.organization'));

	return { orgSettings, orgName };
}
